import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import { format } from '../../../../utils/date';

const InstalledSdks = ({ sdks, store, withFunction = true }) => (
  <div className="insights-details-block__content-table insights-details-block__content-table-sdk">
    <div className="insights-details-block__content-table-head">
      <div className="insights-details-block__content-table-head-item">SDK</div>
      {withFunction && (
        <div className="insights-details-block__content-table-head-item">Function</div>
      )}
      <div className="insights-details-block__content-table-head-item">Install Date</div>
    </div>
    <div className="insights-details-block__content-table-body">
      {sdks.map((sdk) => (
        <div key={sdk.name} className="insights-details-block__content-table-body-item">
          <div className="insights-details-block__content-table-body-item-name">
            <a
              className="d-inline-block link-md text-truncate"
              target="_blank"
              rel="noreferrer"
              href={`/sdks/${store}/${sdk.sdk_id}`}
            >
              {sdk.name}
            </a>
          </div>
          {withFunction && (
            <div className="insights-details-block__content-table-body-item-func text-truncate">
              {!isEmpty(sdk.functions)
                ? sdk.functions.map((func) => SDK_FUNCTIONS[func])
                : 'Miscellaneous'}
            </div>
          )}
          <div className="insights-details-block__content-table-body-item-date">
            {format(sdk.first_detected_at_date, 'MMMM DD, YYYY')}
          </div>
        </div>
      ))}
    </div>
  </div>
);

InstalledSdks.propTypes = {
  sdks: T.array,
  store: T.string,
  withFunction: T.bool,
};

export default InstalledSdks;
